export default "__VITE_ASSET__BtUim$9Q__"